module.exports = __webpack_public_path__ + "img/offer4.dddfca08.png";